import React, { useState } from "react";
import API from "../../services/adminApi";

function ProgramModal({ editData, close }) {
  const [title, setTitle] = useState(editData?.title || "");
  const [description, setDescription] = useState(editData?.description || "");
  const [image, setImage] = useState(null);

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    if (image) formData.append("image", image);

    if (editData) {
      await API.put(`programs/${editData.id}/`, formData);
    } else {
      await API.post("programs/", formData);
    }

    close();
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>{editData ? "Edit" : "Add"} Program</h2>

        <input value={title} onChange={e => setTitle(e.target.value)} />
        <textarea value={description} onChange={e => setDescription(e.target.value)} />

        <input type="file" onChange={e => setImage(e.target.files[0])} />

        <button onClick={handleSubmit}>Save</button>
        <button onClick={close}>Cancel</button>
      </div>
    </div>
  );
}

export default ProgramModal;